import { createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "../hook";
import { RootState } from "../store";
import { criarEstadoBaseDeDashboard, dashboardBaseReducers, DashboardBaseState } from "../dashboardBaseReducers";

export type DashboardState = DashboardBaseState;

const initialState: DashboardState = criarEstadoBaseDeDashboard();

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    ...dashboardBaseReducers,
  },
});

export const {
  setDashboardData,
  setFilters,
  setLoading,
  setError,
  toggleDREItem,
  setOnboardingData,
  completeOnboarding,
  clearFilters,
} = dashboardSlice.actions;

// Selectors
export const getDashboardData = (state: RootState) => state.dashboard.data;
export const getDashboardFilters = (state: RootState) => state.dashboard.filters;
export const getDashboardLoading = (state: RootState) => state.dashboard.loading;
export const getDashboardError = (state: RootState) => state.dashboard.error;
export const getExpandedDREItems = (state: RootState) => state.dashboard.expandedDREItems;
export const getOnboardingData = (state: RootState) => state.dashboard.onboarding;

// Hooks
export const useDashboardData = () => useAppSelector(getDashboardData);
export const useDashboardFilters = () => useAppSelector(getDashboardFilters);
export const useDashboardLoading = () => useAppSelector(getDashboardLoading);
export const useDashboardError = () => useAppSelector(getDashboardError);
export const useExpandedDREItems = () => useAppSelector(getExpandedDREItems);
export const useOnboardingData = () => useAppSelector(getOnboardingData);

export default dashboardSlice.reducer;
